import Button from '@/components/Button/Button';
import Modal from '@/components/Modal/Modal';
import { useTranslation } from 'react-i18next';
import styles from './ConfirmCERPromosModal.module.css';

interface ConfirmCERPromosModalProps {
  onClose: () => void;
  onConfirm: () => void;
  isOpen?: boolean;
  isLoading?: boolean;
}

const ConfirmCERPromosModal = ({ onClose, onConfirm, isOpen, isLoading }: ConfirmCERPromosModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      className={styles.modal}
      headerContent={
        <div className={styles.header}>{t('promotions.promotionsSettings.CERPromosSuccessfullyUpdated')}</div>
      }
      showTitleDivider
      footerContent={
        <div className={styles.footer}>
          <Button onClick={onConfirm} isLoading={isLoading}>
            {t('common.ok')}
          </Button>
        </div>
      }
      onClose={onClose}
      isOpen={!!isOpen}
      bodyContent={
        <div className={styles.body}>
          <p>{t('promotions.promotionsSettings.CERPromosChangesApplyed')}</p>
        </div>
      }
    />
  );
};

export default ConfirmCERPromosModal;
